var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.infoLoading,
          expression: "infoLoading",
        },
      ],
      staticClass: "create__order changeEle__color",
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.ruleForm, "label-width": "auto" },
        },
        [
          _c(
            "el-card",
            {
              staticClass: "box-card modify__from-auditManagement",
              staticStyle: { "margin-bottom": "20px" },
              attrs: { shadow: "never" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title__style-color" }, [
                    _vm._v("订单信息"),
                  ]),
                ]
              ),
              _c("div", { staticClass: "con__style" }, [
                _c(
                  "div",
                  { staticClass: "formBox" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "formBoxForm",
                        attrs: { model: _vm.ruleForm, "label-width": "100px" },
                      },
                      [
                        _c("div", { staticClass: "formBox__row" }, [
                          _c(
                            "div",
                            { staticClass: "formBox__col" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "客户名称",
                                    prop: "customer_id",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择客户名称",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formBox__input",
                                      attrs: {
                                        remote: "",
                                        "remote-method": _vm.remoteMethod,
                                        filterable: "",
                                        clearable: "",
                                        placeholder: "请输入客户名称",
                                        disabled: true,
                                      },
                                      on: { change: _vm.changeCustomer },
                                      model: {
                                        value: _vm.ruleForm.customer_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "customer_id",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.customer_id",
                                      },
                                    },
                                    _vm._l(_vm.companyList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.company_name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.showContect
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "联系人姓名",
                                        prop: "contact_id",
                                        rules: [
                                          {
                                            required: true,
                                            trigger: "change",
                                            message: "请选择联系人姓名",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "formBox__input",
                                          attrs: { placeholder: "请选择" },
                                          on: { change: _vm.changeContact },
                                          model: {
                                            value: _vm.ruleForm.contact_id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "contact_id",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.contact_id",
                                          },
                                        },
                                        _vm._l(
                                          _vm.contactsList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.id,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "仅可选择角色为关键决策人或项目负责人或辅助决策人或项目参与人并有手机号的联系人",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showContect
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "手机号",
                                        prop: "contact_mobile",
                                        rules: [
                                          {
                                            required: true,
                                            trigger: "change",
                                            message: "请选择手机号",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "formBox__input",
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value: _vm.ruleForm.contact_mobile,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "contact_mobile",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.contact_mobile",
                                          },
                                        },
                                        _vm._l(
                                          _vm.mobileList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.mobile,
                                                value: item.mobile_str,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "负责人",
                                    prop: "username",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "负责人信息不能为空",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "formBox__input",
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.ruleForm.username,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "username", $$v)
                                      },
                                      expression: "ruleForm.username",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.proxyCustomer != 2 && _vm.isOrderOpportunity
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "商机",
                                        prop: "user_opportunity_id",
                                        rules: [
                                          {
                                            required:
                                              _vm.channel_id == 1
                                                ? true
                                                : false,
                                            trigger: "change",
                                            message: "请选择商机",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _vm.edit === 0 && _vm.send_type !== 4
                                            ? _c(
                                                "el-select",
                                                {
                                                  staticClass: "formBox__input",
                                                  staticStyle: { flex: "1" },
                                                  attrs: {
                                                    "no-data-text":
                                                      "请选择客户名称",
                                                    filterable: "",
                                                    placeholder: "请选择",
                                                    disabled:
                                                      _vm.disabledFlag ||
                                                      _vm.couponFlag,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.changeOpportunity,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.ruleForm
                                                        .user_opportunity_id,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.ruleForm,
                                                        "user_opportunity_id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "ruleForm.user_opportunity_id",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.opportunityList,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.edit === 1 || _vm.send_type === 4
                                            ? _c("el-input", {
                                                staticClass: "formBox__input",
                                                staticStyle: { flex: "1" },
                                                attrs: {
                                                  disabled:
                                                    _vm.disabledFlag ||
                                                    _vm.couponFlag,
                                                },
                                                model: {
                                                  value:
                                                    _vm.ruleForm
                                                      .opportunity_name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.ruleForm,
                                                      "opportunity_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ruleForm.opportunity_name",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "has",
                                                  rawName: "v-has",
                                                  value:
                                                    "/orders/opportunity/sync-opportunity",
                                                  expression:
                                                    "'/orders/opportunity/sync-opportunity'",
                                                },
                                              ],
                                              staticStyle: {
                                                "margin-left": "8px",
                                                "white-space": "nowrap",
                                              },
                                              attrs: {
                                                disabled: _vm.send_type === 4,
                                                type: "primary",
                                                size: "mini",
                                                loading: _vm.sycOppLoading,
                                              },
                                              on: { click: _vm.sycOpp },
                                            },
                                            [_vm._v("同步商机")]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticStyle: {
                                                "margin-left": "2px",
                                              },
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  "请将商机推进至销售订单阶段，点击同步后加快商机同步",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-warning-outline",
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  cursor: "pointer",
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.proxyCustomer != 2 &&
                              _vm.isOrderOpportunity &&
                              _vm.ruleForm.user_opportunity_id
                                ? _c(
                                    "div",
                                    { staticClass: "formBox__info-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#333" } },
                                        [
                                          _vm._v(
                                            "客户人数：" +
                                              _vm._s(_vm.ruleForm.customers_num)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#333" } },
                                        [
                                          _vm._v(
                                            "人均预算：" +
                                              _vm._s(
                                                _vm.ruleForm.per_capita_budget
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.proxyCustomer != 2 &&
                              _vm.isOrderOpportunity &&
                              _vm.ruleForm.user_opportunity_id
                                ? _c(
                                    "div",
                                    { staticClass: "formBox__info-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#333" } },
                                        [
                                          _vm._v(
                                            "商机金额：" +
                                              _vm._s(_vm.ruleForm.amount)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.special_brands.length > 0
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: { label: "特殊品牌" },
                                    },
                                    _vm._l(
                                      _vm.special_brands,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "5px",
                                                  "margin-right": "5px",
                                                },
                                                attrs: {
                                                  type: "warning",
                                                  plain: "",
                                                  size: "mini",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm.special_menus.length > 0
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: { label: "特殊菜单" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                            gap: "6px",
                                          },
                                        },
                                        _vm._l(
                                          _vm.special_menus,
                                          function (item, index) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: index,
                                                attrs: { size: "medium" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.category_name)
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: { label: "备注" },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "formBox__input",
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入内容",
                                      maxlength: "300",
                                      "show-word-limit": "",
                                      rows: 4,
                                      disabled: _vm.disabledFlag,
                                    },
                                    model: {
                                      value: _vm.ruleForm.remark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "remark", $$v)
                                      },
                                      expression: "ruleForm.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "formBox__col" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "业务类型",
                                    prop: "card_bin_group_id",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择业务类型",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formBox__input",
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: true,
                                      },
                                      on: { change: _vm.changeCardRadio },
                                      model: {
                                        value: _vm.ruleForm.card_bin_group_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "card_bin_group_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "ruleForm.card_bin_group_id",
                                      },
                                    },
                                    _vm._l(
                                      _vm.cardTypeChannelList,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "卡类型",
                                    prop: "card_bin_id",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择卡类型",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formBox__input",
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: true,
                                      },
                                      on: { change: _vm.changeCardType },
                                      model: {
                                        value: _vm.ruleForm.card_bin_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "card_bin_id",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.card_bin_id",
                                      },
                                    },
                                    _vm._l(
                                      _vm.cardTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "商城展示名称",
                                    prop: "card_name",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请输入商城展示名称",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "formBox__input",
                                    model: {
                                      value: _vm.ruleForm.card_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "card_name", $$v)
                                      },
                                      expression: "ruleForm.card_name",
                                    },
                                  }),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticStyle: { "margin-left": "2px" },
                                      attrs: {
                                        effect: "dark",
                                        content: "商城卡包中展示的卡名称",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning-outline",
                                        staticStyle: {
                                          "font-size": "14px",
                                          cursor: "pointer",
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "售卡类型",
                                    prop: "sale_type",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择售卡类型",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formBox__input",
                                      attrs: { placeholder: "请选择" },
                                      on: { change: _vm.changeSaleType },
                                      model: {
                                        value: _vm.ruleForm.sale_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "sale_type",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.sale_type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.saleTypes,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.ruleForm.card_bin_group_id != 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "售卡总金额",
                                        prop: "money",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "请填写售卡总金额，仅限两位小数",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,2})?$/,
                                            message:
                                              "请填写售卡总金额，仅限两位小数",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { disabled: _vm.can_up },
                                        model: {
                                          value: _vm.ruleForm.money,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.ruleForm, "money", $$v)
                                          },
                                          expression: "ruleForm.money",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id != 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "折扣",
                                        prop: "discount",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "请填写 0 -1 范围之间，支持三位小数",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,3})?$/,
                                            message:
                                              "请填写 0 -1 范围之间，支持三位小数",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { disabled: true },
                                        on: { blur: _vm.blurDiscount },
                                        model: {
                                          value: _vm.ruleForm.discount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "discount",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.discount",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id != 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "总点数",
                                        prop: "resource",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.addCard.cardTotal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.addCard,
                                              "cardTotal",
                                              $$v
                                            )
                                          },
                                          expression: "addCard.cardTotal",
                                        },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content: "售卡总金额/折扣",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id == 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "售卡总金额",
                                        prop: "money",
                                        rules: [
                                          {
                                            required: true,
                                            message:
                                              "请填写售卡总金额，仅限两位小数",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,2})?$/,
                                            message:
                                              "请填写售卡总金额，仅限两位小数",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        model: {
                                          value: _vm.ruleForm.money,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.ruleForm, "money", $$v)
                                          },
                                          expression: "ruleForm.money",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id == 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "form__style-width",
                                      attrs: {
                                        label: "单次支付上限",
                                        prop: "max_goods_points",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: {
                                          disabled: "",
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.max_goods_points,
                                          callback: function ($$v) {
                                            _vm.max_goods_points = $$v
                                          },
                                          expression: "max_goods_points",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id == 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "单价",
                                        prop: "discount",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请填写单价，仅限两位小数",
                                          },
                                          {
                                            pattern:
                                              /^(0\.[1-9]\d?|[1-9]\d*(\.\d{1,2})?)$/,
                                            message: "请填写单价，仅限两位小数",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        on: { change: _vm.changeDiscount },
                                        model: {
                                          value: _vm.ruleForm.discount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "discount",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.discount",
                                        },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "1张1次的电影卡券与客户结算的价格",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id == 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "售卡总次数",
                                        prop: "total_points",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.addCard.cardTotal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.addCard,
                                              "cardTotal",
                                              $$v
                                            )
                                          },
                                          expression: "addCard.cardTotal",
                                        },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content: "售卡总金额/单价",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.has_other_menus === 1 &&
                              _vm.ruleForm.card_bin_group_id == 4
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "积分价值",
                                        prop: "other_max_goods_points",
                                        rules: [
                                          {
                                            message: "请填写，仅限小数点后两位",
                                            trigger: "change",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,2})?$/,
                                            message: "请填写，仅限小数点后两位",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value:
                                            _vm.ruleForm.other_max_goods_points,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "other_max_goods_points",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ruleForm.other_max_goods_points",
                                        },
                                      }),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "表示购买非电影商品抵扣的金额",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.ruleForm.card_bin_group_id == 6
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "是否回款",
                                        prop: "is_return_money",
                                        rules: {
                                          required: true,
                                          message: "请选择是否回款",
                                          trigger: "change",
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.ruleForm.is_return_money,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "is_return_money",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.is_return_money",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.disabledFlag
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "优惠券成本",
                                        prop: "service_cost",
                                        rules: [
                                          {
                                            message: "请填写，仅限小数点后两位",
                                            trigger: "change",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,2})?$/,
                                            message: "请填写，仅限小数点后两位",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "formBox__input",
                                          model: {
                                            value: _vm.ruleForm.service_cost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "service_cost",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.service_cost",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "开票金额=应收金额（售卡总金额+优惠券成本）",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.disabledFlag
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "服务成本",
                                        prop: "company_cost",
                                        rules: [
                                          {
                                            trigger: "change",
                                            message: "请填写，仅限小数点后两位",
                                          },
                                          {
                                            pattern: /^\d{1,9}(\.\d{1,2})?$/,
                                            message: "请填写，仅限小数点后两位",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          staticClass: "formBox__input",
                                          model: {
                                            value: _vm.ruleForm.company_cost,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "company_cost",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.company_cost",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "append" }, [
                                            _vm._v("元"),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticStyle: { "margin-left": "2px" },
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "销售业绩以及佣金基数=售卡总金额-服务成本",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-warning-outline",
                                            staticStyle: {
                                              "font-size": "14px",
                                              cursor: "pointer",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.edit == 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "偏差金额",
                                        prop: "diff_money",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请填写偏差金额",
                                          },
                                          {
                                            pattern:
                                              /^[- | +]?\d{1,9}(\.\d{1,2})?$/,
                                            message:
                                              "请填写偏差金额，仅限小数点后两位",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: { placeholder: "请输入正整数" },
                                        model: {
                                          value: _vm.ruleForm.diff_money,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "diff_money",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.diff_money",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.edit == 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "偏差原因",
                                        prop: "diff_remark",
                                        rules: [
                                          {
                                            required:
                                              _vm.ruleForm.diff_money != 0
                                                ? true
                                                : false,
                                            message: "请填写偏差原因",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "formBox__input",
                                        attrs: {
                                          type: "textarea",
                                          rows: 4,
                                          placeholder: "请输入",
                                        },
                                        model: {
                                          value: _vm.ruleForm.diff_remark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "diff_remark",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.diff_remark",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "formBox__col" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "发放类型",
                                    prop: "send_type",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择卡发放类型",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "box_radio",
                                      attrs: { disabled: _vm.couponFlag },
                                      model: {
                                        value: _vm.ruleForm.send_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "send_type",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.send_type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.sendTypeList,
                                      function (item, k) {
                                        return _c(
                                          "el-radio",
                                          { key: k, attrs: { label: item.id } },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.edit == 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "结算方式",
                                        prop: "settlement_type",
                                        rules: [
                                          {
                                            required: true,
                                            trigger: "change",
                                            message: "请选择结算方式",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.ruleForm.settlement_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "settlement_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.settlement_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("按售卡结算")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("按消费结算")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.edit == 1
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticClass: "formBox__item",
                                      attrs: {
                                        label: "佣金核算方式",
                                        prop: "commission_type",
                                        rules: [
                                          {
                                            required: true,
                                            trigger: "change",
                                            message: "请选择佣金核算方式",
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "box_radio",
                                          model: {
                                            value: _vm.ruleForm.commission_type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "commission_type",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "ruleForm.commission_type",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("自动核算")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("人工未核算")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("人工已核算")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "售卡方式",
                                    prop: "how_to_sell_cards",
                                    rules: [
                                      {
                                        required: true,
                                        trigger: "change",
                                        message: "请选择售卡方式",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.ruleForm.how_to_sell_cards,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "how_to_sell_cards",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "ruleForm.how_to_sell_cards",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("人工售卡"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("系统自动售卡"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "formBox__item",
                                  attrs: {
                                    label: "交付负责人",
                                    prop: "the_loser_id",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "formBox__input",
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        placeholder: "请选择",
                                        disabled: _vm.edit == 0,
                                      },
                                      model: {
                                        value: _vm.ruleForm.the_loser_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "the_loser_id",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.the_loser_id",
                                      },
                                    },
                                    _vm._l(_vm.sellUserList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm.edit === 0
            ? _c(
                "el-card",
                {
                  staticClass: "box-card modify__from-auditManagement",
                  attrs: { shadow: "never" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "title__style-color" }, [
                        _vm._v("订单规则"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "card__money-box modify__from" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input__style-color",
                          attrs: {
                            label: "有效期范围(月)",
                            prop: "sale_type",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择有效期范围",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.disabledFlag,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeRange(1)
                                },
                              },
                              model: {
                                value: _vm.ruleForm.order_card_sale_rule_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "order_card_sale_rule_id",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.order_card_sale_rule_id",
                              },
                            },
                            _vm._l(_vm.validRange, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input__style-color",
                          attrs: { label: "业绩增减比例" },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              disabled: true,
                              placeholder: "请选择有效期范围",
                            },
                            model: {
                              value: _vm.propertion,
                              callback: function ($$v) {
                                _vm.propertion = $$v
                              },
                              expression: "propertion",
                            },
                          }),
                          _vm._v(" % "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card__money-box modify__from input__style-color",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "延期范围(月)",
                            prop: "sale_type",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择延期范围",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                disabled: _vm.disabledFlag,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeRange(2)
                                },
                              },
                              model: {
                                value: _vm.ruleForm.order_delay_rule_id,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "order_delay_rule_id",
                                    $$v
                                  )
                                },
                                expression: "ruleForm.order_delay_rule_id",
                              },
                            },
                            _vm._l(_vm.inValidRange, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "业绩增减比例" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              disabled: true,
                              placeholder: "请选择延期范围",
                            },
                            model: {
                              value: _vm.propertion1,
                              callback: function ($$v) {
                                _vm.propertion1 = $$v
                              },
                              expression: "propertion1",
                            },
                          }),
                          _vm._v(" % "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card__money-box modify__from input__style-color",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "客户类型",
                            rules: [
                              {
                                required: true,
                                trigger: "change",
                                message: "请选择客户类型",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.ruleForm.customer_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "customer_type", $$v)
                                },
                                expression: "ruleForm.customer_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  "一类客户 [政府机构/事业单位/国有控股、国有独资企业"
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v(
                                  "二类客户 [国有参股企业(实缴资本＞1000万)]"
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("三类客户 [除一类、二类之外的企业]"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "设置", visible: _vm.dialogVisible, width: "380px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm1",
              attrs: { model: _vm.ruleForm1, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "佣金",
                    prop: "sale_commision",
                    rules: [
                      { required: true, message: "请填写佣金" },
                      {
                        pattern:
                          /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|0|^100(\.0{1,2}){0,1}$/,
                        message: "请输入数字格式,限两位小数",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入佣金" },
                    model: {
                      value: _vm.ruleForm1.sale_commision,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "sale_commision", $$v)
                      },
                      expression: "ruleForm1.sale_commision",
                    },
                  }),
                  _vm._v(" % "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "计入业绩",
                    prop: "achievement",
                    rules: [
                      { required: true, message: "请填写计入业绩" },
                      {
                        pattern:
                          /^\d\.([1-9]{1,2}|[0-9][1-9])$|^[1-9]\d{0,1}(\.\d{1,2}){0,1}$|0|^100(\.0{1,2}){0,1}$/,
                        message: "请输入数字格式,限两位小数",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "请输入计入业绩" },
                    model: {
                      value: _vm.ruleForm1.achievement,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "achievement", $$v)
                      },
                      expression: "ruleForm1.achievement",
                    },
                  }),
                  _vm._v(" % "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer dialog-footer-new",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addOrder(true)
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: {
            type: "primary",
            loading: _vm.submitLoading,
            disabled: _vm.can_up,
          },
          on: { click: _vm.submitOrder },
        },
        [_vm._v(_vm._s(_vm.edit === 0 ? "新建订单" : "保存"))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }